import React from 'react';

import { Resource } from '../../../../common/constants/resource';
import { MVR } from '../../../tasks/types/mvr';
import styles from './mvr.module.scss';
import { MVRApplicantInfoBar } from './MVRApplicantInfoBar';
import { MVRLicenseInfoBars } from './MVRLicenseInfoBars';
import { MVRMiscPanel } from './MVRMiscPanel';
import { MVRViolationsTable } from './MVRViolationsTable';

/** Pixel-matched MVR panel (feature-flagged redesign). */
export const MVRRedesignPanel = ({
  mvr,
  errorMessage,
}: {
  mvr: MVR | null;
  errorMessage?: string;
  evidenceId?: number;
}) => {
  if (!mvr) {
    return <></>;
  }
  if (mvr.recordClear) {
    return <p>{Resource.MVR_CLEAR}</p>;
  }
  if (!mvr.recordExists) {
    return errorMessage ? <></> : <p>{Resource.MVR_NO_RECORD}</p>;
  }

  return (
    <div className={styles.panel}>
      {mvr.applicant && <MVRApplicantInfoBar applicant={mvr.applicant} />}
      {mvr.licenseInfo && (
        <MVRLicenseInfoBars licenseInfo={mvr.licenseInfo} />
      )}
      {mvr.driverRecord && (
        <MVRViolationsTable driverRecord={mvr.driverRecord} />
      )}
      {mvr.miscellaneous && (
        <MVRMiscPanel miscellaneous={mvr.miscellaneous} />
      )}
    </div>
  );
};
